var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-detail-tips" }, [
    _vm.isOldVilocalSku ? _c("div", [_vm._v("Free trial set ")]) : _vm._e(),
    _vm._v(" "),
    !_vm.isOldVilocalSku && _vm.consignNum > 0 && _vm.freeTrialNum > 0
      ? _c("div", [
          _vm._v(_vm._s(_vm.freeTrialNum) + " item"),
          _vm.freeTrialNum > 1 ? _c("span", [_vm._v("s")]) : _vm._e(),
          _vm._v(" for free trial and " + _vm._s(_vm.consignNum) + " item"),
          _vm.consignNum > 1 ? _c("span", [_vm._v("s")]) : _vm._e(),
          _vm._v(" with free returns.")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isOldVilocalSku &&
    _vm.consignNum > 0 &&
    (_vm.freeTrialNum === null || _vm.freeTrialNum <= 0)
      ? _c("div", [
          _vm._v(_vm._s(_vm.consignNum) + " item"),
          _vm.consignNum > 1 ? _c("span", [_vm._v("s")]) : _vm._e(),
          _vm._v(" with free returns.")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isOldVilocalSku &&
    _vm.freeTrialNum > 0 &&
    (_vm.consignNum === null || _vm.consignNum <= 0)
      ? _c("div", [
          _vm._v(_vm._s(_vm.freeTrialNum) + " item"),
          _vm.freeTrialNum > 1 ? _c("span", [_vm._v("s")]) : _vm._e(),
          _vm._v(" free trial.")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isOldVilocalSku && _vm.vilocalType === 4
      ? _c("div", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.num +
                  " item for " +
                  Number(_vm.discountTrialRate).toFixed(0) +
                  "% trial"
              ) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23f8e76c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f8e76c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/vilocal-order-detail.vue
// module id = null
// module chunks = 